import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
import { defineComponent, reactive } from "vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import Head from "@/components/Head/index.vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

export default defineComponent({
  name: "ReadBook",
  components: {
    Head: Head
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var route = useRoute();
    var router = useRouter();
    var detail = reactive({
      data: {},
      bookcontent: "",
      chapterName: ""
    });
    var _route$query = route.query,
        id = _route$query.id,
        chapterId = _route$query.chapterId,
        total = _route$query.total;
    var baseurl = process.env.VUE_APP_BASE_API;
    var totalNum = Number(total);
    var chapterIdChange = Number(chapterId); //获取图书详情

    function getAllBookbyDetail() {
      return _getAllBookbyDetail.apply(this, arguments);
    } //获取本章内容


    function _getAllBookbyDetail() {
      _getAllBookbyDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$globalProperti, data, code;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getAllBookbyDetail"]({
                  bookId: id
                });

              case 2:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                code = _yield$globalProperti.code;

                if (code == 0) {
                  detail.data = data;
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getAllBookbyDetail.apply(this, arguments);
    }

    function getBookcontentByCatalog(_x) {
      return _getBookcontentByCatalog.apply(this, arguments);
    }

    function _getBookcontentByCatalog() {
      _getBookcontentByCatalog = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(res) {
        var _yield$globalProperti2, data, code, content, noContent, nomal;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getBookcontentByCatalog"]({
                  bookId: id,
                  chapterId: res
                });

              case 2:
                _yield$globalProperti2 = _context2.sent;
                data = _yield$globalProperti2.data;
                code = _yield$globalProperti2.code;

                if (code == 0) {
                  detail.chapterName = data.chapterName;
                  content = data.chapterContent.replace(/[\n\r]/g, '</p><p style="min-height:28px;text-indent: 2em;">');
                  noContent = content.replace(/\s+/g, '');
                  nomal = noContent.replaceAll("<ps", '<p s');
                  detail.bookcontent = '<p style="min-height:28px;text-indent: 2em;">' + nomal + '</p>'; //调整滚动条位置

                  window.scrollTo(0, 0);
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _getBookcontentByCatalog.apply(this, arguments);
    }

    function toChapterDetail() {
      router.go(-1);
    }

    getAllBookbyDetail();
    getBookcontentByCatalog(chapterIdChange); //上一章

    function lastChapter() {
      return _lastChapter.apply(this, arguments);
    } //下一章


    function _lastChapter() {
      _lastChapter = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$globalProperti3, code;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(chapterIdChange == 1)) {
                  _context3.next = 3;
                  break;
                }

                ElMessage({
                  message: "当前已是第一页",
                  type: "warning"
                });
                return _context3.abrupt("return");

              case 3:
                _context3.next = 5;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getBookSaveCatalog"]({
                  bookId: id,
                  chapterId: Number(chapterIdChange) - 1,
                  reading: 0
                });

              case 5:
                _yield$globalProperti3 = _context3.sent;
                code = _yield$globalProperti3.code;

                if (code == 0) {
                  chapterIdChange--;
                  getBookcontentByCatalog(chapterIdChange);
                }

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _lastChapter.apply(this, arguments);
    }

    function nextChapter() {
      return _nextChapter.apply(this, arguments);
    }

    function _nextChapter() {
      _nextChapter = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _yield$globalProperti4, code;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(chapterIdChange == totalNum)) {
                  _context4.next = 3;
                  break;
                }

                ElMessage({
                  message: "当前已是最后一页",
                  type: "warning"
                });
                return _context4.abrupt("return");

              case 3:
                _context4.next = 5;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getBookSaveCatalog"]({
                  bookId: id,
                  chapterId: Number(chapterIdChange) + 1,
                  reading: 0
                });

              case 5:
                _yield$globalProperti4 = _context4.sent;
                code = _yield$globalProperti4.code;

                if (code == 0) {
                  chapterIdChange++;
                  getBookcontentByCatalog(chapterIdChange);
                }

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _nextChapter.apply(this, arguments);
    }

    document.onkeydown = function (e) {
      var key = e.keyCode;

      if (key == 39) {
        nextChapter();
      }

      if (key == 37) {
        lastChapter();
      }
    };

    return {
      baseurl: baseurl,
      detail: detail,
      getAllBookbyDetail: getAllBookbyDetail,
      getBookcontentByCatalog: getBookcontentByCatalog,
      lastChapter: lastChapter,
      nextChapter: nextChapter,
      toChapterDetail: toChapterDetail
    };
  }
});